import { authFetch } from "../utils/fetch";
import { BASE_PATH } from "../utils/constants";

export async function registerApi(formData) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/customers`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    // console.log(result);
    return result;
  } catch (error) {
    console.log(error);
    return error;
  }
}

export async function loginApi(formData) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/login`;
    const params = {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getMeApi(token) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/me`;
    const params = {
      method: "GET",
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(url, params);
    console.log('getMeApi response status:', response.status);

    if (!response.ok) {
      console.error('getMeApi failed with status:', response.status);
      return null;
    }

    const result = await response.json();
    console.log('getMeApi result:', result);
    return result;
  } catch (error) {
    console.error('getMeApi error:', error);
    return null;
  }
}

export async function forgotPassword(formData) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/forgot-password`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function resetPassword(formData) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/customers/reset-password`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    };
    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    console.log(error);
    return null;
  }
}

export async function getNotificationsApi(token) {
  console.log('getNotificationsApi token:', token);
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/notifications`;
    const params = {
      method: "GET",
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    const response = await fetch(url, params);

    if (!response.ok) {
      console.error('getNotificationsApi failed with status:', response.status);
      return null;
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('getNotificationsApi error:', error);
    return null;
  }
}

export async function markNotificationAsReadApi(notificationId, token) {
  try {
    const url = `${process.env.REACT_APP_API_URL}/api/notifications/${notificationId}`;
    const params = {
      method: "PATCH",
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ read: true }),
    };
    const response = await fetch(url, params);

    if (!response.ok) {
      console.error('markNotificationAsReadApi failed with status:', response.status);
      let message = 'No se pudo marcar la notificación como leída. Inténtalo de nuevo.';
      try {
        const errorData = await response.json();
        if (errorData?.message) {
          message = errorData.message;
        }
      } catch (parseError) {
        // Keep the default message when the API does not return JSON
      }
      return { error: true, status: response.status, message };
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('markNotificationAsReadApi error:', error);
    return {
      error: true,
      message: 'No se pudo marcar la notificación como leída. Inténtalo de nuevo.',
    };
  }
}
